"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const it_1 = require("../../../backend/src/app/acl_module/config/i18n/it");
const it_2 = __importDefault(require("./landing/it"));
const onboarding_tooltip_1 = __importDefault(require("./it/onboarding_tooltip"));
const knowledge_picker_1 = __importDefault(require("./it/knowledge_picker"));
const app_page_1 = __importDefault(require("./it/app_page"));
const app_intext_1 = __importDefault(require("./it/app_intext"));
const modal_share_1 = __importDefault(require("./it/modal_share"));
const modal_settings_1 = __importDefault(require("./it/modal_settings"));
const chat_entry_1 = __importDefault(require("./it/chat_entry"));
const user_form_1 = __importDefault(require("./it/user_form"));
const slot_goal_1 = __importDefault(require("./it/slot_goal"));
const slot_target_1 = __importDefault(require("./it/slot_target"));
const slot_format_1 = __importDefault(require("./it/slot_format"));
const slotData_create_1 = __importDefault(require("./it/slotData_create"));
const slotData_load_1 = __importDefault(require("./it/slotData_load"));
const slotData_form_1 = __importDefault(require("./it/slotData_form"));
const slotData_type_1 = __importDefault(require("./it/slotData_type"));
const app_pagination_1 = __importDefault(require("./it/app_pagination"));
const payment_validation_1 = __importDefault(require("./it/payment_validation"));
const payment_status_1 = __importDefault(require("./it/payment_status"));
const payment_stripe_1 = __importDefault(require("./it/payment_stripe"));
const payment_provider_1 = __importDefault(require("./it/payment_provider"));
const payment_confirmed_1 = __importDefault(require("./it/payment_confirmed"));
const route_payment_1 = __importDefault(require("./it/route_payment"));
const payment_search_1 = __importDefault(require("./it/payment_search"));
const payment_preview_1 = __importDefault(require("./it/payment_preview"));
const user_roles_1 = __importDefault(require("./it/user_roles"));
const user_grade_1 = __importDefault(require("./it/user_grade"));
const userGroup_form_1 = __importDefault(require("./it/userGroup_form"));
const userGroup_error_1 = __importDefault(require("./it/userGroup_error"));
const user_profile_1 = __importDefault(require("./it/user_profile"));
const company_preview_1 = __importDefault(require("./it/company_preview"));
const company_tooltips_1 = __importDefault(require("./it/company_tooltips"));
const company_form_1 = __importDefault(require("./it/company_form"));
const access_status_1 = __importDefault(require("./it/access_status"));
const access_list_1 = __importDefault(require("./it/access_list"));
const avatar_processing_1 = __importDefault(require("./it/avatar_processing"));
const avatar_form_1 = __importDefault(require("./it/avatar_form"));
const webhook_eventTypes_1 = __importDefault(require("./it/webhook_eventTypes"));
const webhook_cronIntervals_1 = __importDefault(require("./it/webhook_cronIntervals"));
const tools_imgGen_1 = __importDefault(require("./it/tools_imgGen"));
const tools_convoTags_1 = __importDefault(require("./it/tools_convoTags"));
const tools_galleryTags_1 = __importDefault(require("./it/tools_galleryTags"));
const tools_detectContactData_1 = __importDefault(require("./it/tools_detectContactData"));
const tools_detectTasks_1 = __importDefault(require("./it/tools_detectTasks"));
const tools_productCompare_1 = __importDefault(require("./it/tools_productCompare"));
const tools_askForVoucher_1 = __importDefault(require("./it/tools_askForVoucher"));
const tools_offerCreator_1 = __importDefault(require("./it/tools_offerCreator"));
const tools_quickOffer_1 = __importDefault(require("./it/tools_quickOffer"));
const tools_sendContactForm_1 = __importDefault(require("./it/tools_sendContactForm"));
const tools_apiTool_1 = __importDefault(require("./it/tools_apiTool"));
const tools_productAPISearch_1 = __importDefault(require("./it/tools_productAPISearch"));
const tools_dynamicListings_1 = __importDefault(require("./it/tools_dynamicListings"));
const tools_productCard_1 = __importDefault(require("./it/tools_productCard"));
const tools_personalData_1 = __importDefault(require("./it/tools_personalData"));
const tools_rag_1 = __importDefault(require("./it/tools_rag"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./it/tools_aiFormAnalyzer"));
const avatar_common_1 = __importDefault(require("./it/avatar_common"));
const avatar_active_1 = __importDefault(require("./it/avatar_active"));
const avatar_tooltips_1 = __importDefault(require("./it/avatar_tooltips"));
const avatar_knowledge_1 = __importDefault(require("./it/avatar_knowledge"));
const avatar_preview_1 = __importDefault(require("./it/avatar_preview"));
const style_form_1 = __importDefault(require("./it/style_form"));
const accountGrade_list_1 = __importDefault(require("./it/accountGrade_list"));
const accountGrade_form_1 = __importDefault(require("./it/accountGrade_form"));
const limits_avatar_1 = __importDefault(require("./it/limits_avatar"));
const limits_user_1 = __importDefault(require("./it/limits_user"));
const limits_project_1 = __importDefault(require("./it/limits_project"));
const limits_knowledge_1 = __importDefault(require("./it/limits_knowledge"));
const limits_customModel_1 = __importDefault(require("./it/limits_customModel"));
const limits_writingStyles_1 = __importDefault(require("./it/limits_writingStyles"));
const limits_advanced_prompts_1 = __importDefault(require("./it/limits_advanced-prompts"));
const limits_prompt_assist_1 = __importDefault(require("./it/limits_prompt-assist"));
const limits_anti_hallucination_1 = __importDefault(require("./it/limits_anti-hallucination"));
const limits_advanced_reports_1 = __importDefault(require("./it/limits_advanced-reports"));
const limits_chat_thread_sharing_1 = __importDefault(require("./it/limits_chat-thread-sharing"));
const limits_custom_branding_1 = __importDefault(require("./it/limits_custom-branding"));
const limits_widgets_1 = __importDefault(require("./it/limits_widgets"));
const limits_voice_agent_1 = __importDefault(require("./it/limits_voice-agent"));
const limits_upgrade_1 = __importDefault(require("./it/limits_upgrade"));
const voice_chat_error_1 = __importDefault(require("./it/voice-chat_error"));
const email_pass_reset_1 = __importDefault(require("./it/email_pass_reset"));
const email_activation_1 = __importDefault(require("./it/email_activation"));
const email_upgrade_1 = __importDefault(require("./it/email_upgrade"));
const email_payment_1 = __importDefault(require("./it/email_payment"));
const register_complete_1 = __importDefault(require("./it/register_complete"));
const password_reset_1 = __importDefault(require("./it/password_reset"));
const accountGrade_preview_1 = __importDefault(require("./it/accountGrade_preview"));
const table_controls_1 = __importDefault(require("./it/table_controls"));
const route_settings_1 = __importDefault(require("./it/route_settings"));
const route_style_1 = __importDefault(require("./it/route_style"));
const route_company_1 = __importDefault(require("./it/route_company"));
const route_user_1 = __importDefault(require("./it/route_user"));
const route_accountGrade_1 = __importDefault(require("./it/route_accountGrade"));
const route_userGroup_1 = __importDefault(require("./it/route_userGroup"));
const route_user_group_1 = __importDefault(require("./it/route_user_group"));
const route_branch_1 = __importDefault(require("./it/route_branch"));
const route_profession_1 = __importDefault(require("./it/route_profession"));
const route_avatar_1 = __importDefault(require("./it/route_avatar"));
const route_conversation_1 = __importDefault(require("./it/route_conversation"));
const route_botTest_1 = __importDefault(require("./it/route_botTest"));
const route_tutorial_1 = __importDefault(require("./it/route_tutorial"));
const tutorial_create_1 = __importDefault(require("./it/tutorial_create"));
const tutorial_edit_1 = __importDefault(require("./it/tutorial_edit"));
const tutorial_preview_1 = __importDefault(require("./it/tutorial_preview"));
const tutorial_delete_1 = __importDefault(require("./it/tutorial_delete"));
const tutorial_list_1 = __importDefault(require("./it/tutorial_list"));
const tutorial_start_1 = __importDefault(require("./it/tutorial_start"));
const tutorial_new_section_1 = __importDefault(require("./it/tutorial_new-section"));
const tutorial_search_1 = __importDefault(require("./it/tutorial_search"));
const tutorial_form_1 = __importDefault(require("./it/tutorial_form"));
const tutorial_validation_1 = __importDefault(require("./it/tutorial_validation"));
const tutorial_todos_1 = __importDefault(require("./it/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./it/tutorial_statistics"));
const tutorial_errors_1 = __importDefault(require("./it/tutorial_errors"));
const botTest_create_1 = __importDefault(require("./it/botTest_create"));
const botTest_edit_1 = __importDefault(require("./it/botTest_edit"));
const botTest_tester_1 = __importDefault(require("./it/botTest_tester"));
const botTest_target_1 = __importDefault(require("./it/botTest_target"));
const botTest_list_1 = __importDefault(require("./it/botTest_list"));
const botTest_actions_1 = __importDefault(require("./it/botTest_actions"));
const botTest_preview_1 = __importDefault(require("./it/botTest_preview"));
const botTest_testResults_1 = __importDefault(require("./it/botTest_testResults"));
const route_ai_1 = __importDefault(require("./it/route_ai"));
const ai_models_1 = __importDefault(require("./it/ai_models"));
const ai_com_1 = __importDefault(require("./it/ai_com"));
const ai_fields_1 = __importDefault(require("./it/ai_fields"));
const ai_controls_1 = __importDefault(require("./it/ai_controls"));
const ai_assist_suggestions_1 = __importDefault(require("./it/ai-assist_suggestions"));
const ai_suggestions_1 = __importDefault(require("./it/ai_suggestions"));
const ai_assist_1 = __importDefault(require("./it/ai_assist"));
const conversation_type_1 = __importDefault(require("./it/conversation_type"));
const conversation_agent_1 = __importDefault(require("./it/conversation_agent"));
const conversation_session_1 = __importDefault(require("./it/conversation_session"));
const conversation_avatar_1 = __importDefault(require("./it/conversation_avatar"));
const conversation_voice_1 = __importDefault(require("./it/conversation_voice"));
const conversation_clear_1 = __importDefault(require("./it/conversation_clear"));
const conversation_auto_1 = __importDefault(require("./it/conversation_auto"));
const conversation_start_1 = __importDefault(require("./it/conversation_start"));
const conversation_stop_1 = __importDefault(require("./it/conversation_stop"));
const conversation_recording_1 = __importDefault(require("./it/conversation_recording"));
const recording_start_1 = __importDefault(require("./it/recording_start"));
const recording_process_1 = __importDefault(require("./it/recording_process"));
const conversation_end_1 = __importDefault(require("./it/conversation_end"));
const message_send_1 = __importDefault(require("./it/message_send"));
const microphone_access_1 = __importDefault(require("./it/microphone_access"));
const conversation_interruption_1 = __importDefault(require("./it/conversation_interruption"));
const conversations_search_1 = __importDefault(require("./it/conversations_search"));
const conversations_date_1 = __importDefault(require("./it/conversations_date"));
const conversations_error_1 = __importDefault(require("./it/conversations_error"));
const conversations_delete_1 = __importDefault(require("./it/conversations_delete"));
const conversations_favorite_1 = __importDefault(require("./it/conversations_favorite"));
const account_upgrade_1 = __importDefault(require("./it/account_upgrade"));
const account_grades_1 = __importDefault(require("./it/account_grades"));
const route_knowledge_1 = __importDefault(require("./it/route_knowledge"));
const route_knowledgeProject_1 = __importDefault(require("./it/route_knowledgeProject"));
const knowledge_title_1 = __importDefault(require("./it/knowledge_title"));
const knowledge_description_1 = __importDefault(require("./it/knowledge_description"));
const knowledge_content_1 = __importDefault(require("./it/knowledge_content"));
const knowledge_tags_1 = __importDefault(require("./it/knowledge_tags"));
const knowledge_active_1 = __importDefault(require("./it/knowledge_active"));
const knowledge_filter_1 = __importDefault(require("./it/knowledge_filter"));
const knowledge_project_1 = __importDefault(require("./it/knowledge_project"));
const project_form_1 = __importDefault(require("./it/project_form"));
const project_name_1 = __importDefault(require("./it/project_name"));
const project_description_1 = __importDefault(require("./it/project_description"));
const project_icon_1 = __importDefault(require("./it/project_icon"));
const knowledge_native_1 = __importDefault(require("./it/knowledge_native"));
const knowledge_ragStatus_1 = __importDefault(require("./it/knowledge_ragStatus"));
const knowledge_statusInfo_1 = __importDefault(require("./it/knowledge_statusInfo"));
const knowledge_form_1 = __importDefault(require("./it/knowledge_form"));
const knowledge_bulk_upload_1 = __importDefault(require("./it/knowledge_bulk_upload"));
const knowledge_preview_1 = __importDefault(require("./it/knowledge_preview"));
const knowledgeProject_form_1 = __importDefault(require("./it/knowledgeProject_form"));
const knowledgeProject_name_1 = __importDefault(require("./it/knowledgeProject_name"));
const knowledgeProject_description_1 = __importDefault(require("./it/knowledgeProject_description"));
const knowledgeProject_icon_1 = __importDefault(require("./it/knowledgeProject_icon"));
const chat_teaser_1 = __importDefault(require("./it/chat_teaser"));
const chat_heading_1 = __importDefault(require("./it/chat_heading"));
const chat_config_1 = __importDefault(require("./it/chat_config"));
const chat_noCredits_1 = __importDefault(require("./it/chat_noCredits"));
const file_upload_1 = __importDefault(require("./it/file_upload"));
const file_clipboard_1 = __importDefault(require("./it/file_clipboard"));
const trainer_reset_1 = __importDefault(require("./it/trainer_reset"));
const trainer_tab_1 = __importDefault(require("./it/trainer_tab"));
const trainer_upload_1 = __importDefault(require("./it/trainer_upload"));
const trainer_config_1 = __importDefault(require("./it/trainer_config"));
const chat_sync_1 = __importDefault(require("./it/chat_sync"));
const ai_chat_1 = __importDefault(require("./it/ai_chat"));
const branch_list_1 = __importDefault(require("./it/branch_list"));
const branch_create_1 = __importDefault(require("./it/branch_create"));
const branch_edit_1 = __importDefault(require("./it/branch_edit"));
const branch_search_1 = __importDefault(require("./it/branch_search"));
const branch_delete_1 = __importDefault(require("./it/branch_delete"));
const branch_form_1 = __importDefault(require("./it/branch_form"));
const profession_list_1 = __importDefault(require("./it/profession_list"));
const profession_create_1 = __importDefault(require("./it/profession_create"));
const profession_edit_1 = __importDefault(require("./it/profession_edit"));
const profession_search_1 = __importDefault(require("./it/profession_search"));
const profession_delete_1 = __importDefault(require("./it/profession_delete"));
const profession_form_1 = __importDefault(require("./it/profession_form"));
const profession_common_1 = __importDefault(require("./it/profession_common"));
const step_shared_1 = __importDefault(require("./it/step_shared"));
const step_list_1 = __importDefault(require("./it/step_list"));
const step_create_1 = __importDefault(require("./it/step_create"));
const step_edit_1 = __importDefault(require("./it/step_edit"));
const step_search_1 = __importDefault(require("./it/step_search"));
const step_delete_1 = __importDefault(require("./it/step_delete"));
const step_form_1 = __importDefault(require("./it/step_form"));
const question_list_1 = __importDefault(require("./it/question_list"));
const question_create_1 = __importDefault(require("./it/question_create"));
const question_edit_1 = __importDefault(require("./it/question_edit"));
const question_search_1 = __importDefault(require("./it/question_search"));
const question_delete_1 = __importDefault(require("./it/question_delete"));
const question_form_1 = __importDefault(require("./it/question_form"));
const question_type_1 = __importDefault(require("./it/question_type"));
const onboarding_intro_1 = __importDefault(require("./it/onboarding_intro"));
const onboarding_list_1 = __importDefault(require("./it/onboarding_list"));
const onboarding_create_1 = __importDefault(require("./it/onboarding_create"));
const onboarding_edit_1 = __importDefault(require("./it/onboarding_edit"));
const onboarding_search_1 = __importDefault(require("./it/onboarding_search"));
const onboarding_delete_1 = __importDefault(require("./it/onboarding_delete"));
const onboarding_status_1 = __importDefault(require("./it/onboarding_status"));
const onboarding_wizard_1 = __importDefault(require("./it/onboarding_wizard"));
const onboarding_benefits_1 = __importDefault(require("./it/onboarding_benefits"));
const onboarding_button_1 = __importDefault(require("./it/onboarding_button"));
const onboarding_image_1 = __importDefault(require("./it/onboarding_image"));
const onboarding_faq_1 = __importDefault(require("./it/onboarding_faq"));
const onboarding_setup_1 = __importDefault(require("./it/onboarding_setup"));
const onboarding_knowledge_1 = __importDefault(require("./it/onboarding_knowledge"));
const onboarding_avatar_1 = __importDefault(require("./it/onboarding_avatar"));
const onboarding_profession_1 = __importDefault(require("./it/onboarding_profession"));
const voices_david_1 = __importDefault(require("./it/voices_david"));
const voices_bradford_1 = __importDefault(require("./it/voices_bradford"));
const voices_clyde_1 = __importDefault(require("./it/voices_clyde"));
const voices_natalie_1 = __importDefault(require("./it/voices_natalie"));
const voices_jane_1 = __importDefault(require("./it/voices_jane"));
const voices_magdalena_1 = __importDefault(require("./it/voices_magdalena"));
const onboarding_records_1 = __importDefault(require("./it/onboarding_records"));
const onboarding_record_1 = __importDefault(require("./it/onboarding_record"));
const onboarding_warning_1 = __importDefault(require("./it/onboarding_warning"));
const onboarding_step_1 = __importDefault(require("./it/onboarding_step"));
const onboarding_questions_1 = __importDefault(require("./it/onboarding_questions"));
const onboarding_pagination_1 = __importDefault(require("./it/onboarding_pagination"));
const onboarding_progress_1 = __importDefault(require("./it/onboarding_progress"));
const onboarding_stats_1 = __importDefault(require("./it/onboarding_stats"));
const onboarding_view_1 = __importDefault(require("./it/onboarding_view"));
const onboarding_pick_1 = __importDefault(require("./it/onboarding_pick"));
const onboarding_error_1 = __importDefault(require("./it/onboarding_error"));
const onboarding_success_1 = __importDefault(require("./it/onboarding_success"));
const onboarding_notify_1 = __importDefault(require("./it/onboarding_notify"));
const login_username_1 = __importDefault(require("./it/login_username"));
const login_password_1 = __importDefault(require("./it/login_password"));
const login_form_1 = __importDefault(require("./it/login_form"));
const register_name_1 = __importDefault(require("./it/register_name"));
const register_username_1 = __importDefault(require("./it/register_username"));
const register_email_1 = __importDefault(require("./it/register_email"));
const register_password_1 = __importDefault(require("./it/register_password"));
const register_repeat_password_1 = __importDefault(require("./it/register_repeat_password"));
const register_form_1 = __importDefault(require("./it/register_form"));
const register_company_1 = __importDefault(require("./it/register_company"));
const activate_hero_1 = __importDefault(require("./it/activate_hero"));
const activate_page_1 = __importDefault(require("./it/activate_page"));
const activate_loading_1 = __importDefault(require("./it/activate_loading"));
const activate_success_1 = __importDefault(require("./it/activate_success"));
const activate_error_1 = __importDefault(require("./it/activate_error"));
const activate_button_1 = __importDefault(require("./it/activate_button"));
const settings_general_1 = __importDefault(require("./it/settings_general"));
const settings_socialMedia_1 = __importDefault(require("./it/settings_socialMedia"));
const settings_rag_1 = __importDefault(require("./it/settings_rag"));
const rag_settings_1 = __importDefault(require("./it/rag_settings"));
const settings_credit_1 = __importDefault(require("./it/settings_credit"));
const rag_file_1 = __importDefault(require("./it/rag_file"));
const settings_googleDrive_1 = __importDefault(require("./it/settings_googleDrive"));
const googleDrive_picker_1 = __importDefault(require("./it/googleDrive_picker"));
const settings_status_1 = __importDefault(require("./it/settings_status"));
const route_reports_1 = __importDefault(require("./it/route_reports"));
const reports_access_1 = __importDefault(require("./it/reports_access"));
const reports_costReports_1 = __importDefault(require("./it/reports_costReports"));
const reports_export_1 = __importDefault(require("./it/reports_export"));
const reports_period_1 = __importDefault(require("./it/reports_period"));
const chat_settings_1 = __importDefault(require("./it/chat_settings"));
const config_tooltips_1 = __importDefault(require("./it/config_tooltips"));
const share_conversation_1 = __importDefault(require("./it/share_conversation"));
const autocomplete_triggers_1 = __importDefault(require("./it/autocomplete_triggers"));
const reports_shared_1 = __importDefault(require("./it/reports_shared"));
const acl_table_1 = __importDefault(require("./it/acl_table"));
const shortcuts_button_1 = __importDefault(require("./it/shortcuts_button"));
const shortcuts_table_1 = __importDefault(require("./it/shortcuts_table"));
const shortcuts_knowledge_1 = __importDefault(require("./it/shortcuts_knowledge"));
const shortcuts_new_1 = __importDefault(require("./it/shortcuts_new"));
const shortcuts_settings_1 = __importDefault(require("./it/shortcuts_settings"));
const shortcuts_find_1 = __importDefault(require("./it/shortcuts_find"));
const shortcuts_prompt_1 = __importDefault(require("./it/shortcuts_prompt"));
const currency_error_1 = __importDefault(require("./it/currency_error"));
const nav_avatar_1 = __importDefault(require("./it/nav_avatar"));
const nav_model_1 = __importDefault(require("./it/nav_model"));
const nav_ai_1 = __importDefault(require("./it/nav_ai"));
const googleDrive_directoryPicker_1 = __importDefault(require("./it/googleDrive_directoryPicker"));
const knowledge_bulkUpload_1 = __importDefault(require("./it/knowledge_bulkUpload"));
const dblogs_filter_1 = __importDefault(require("./it/dblogs_filter"));
const dblogs_results_1 = __importDefault(require("./it/dblogs_results"));
const dblogs_col_1 = __importDefault(require("./it/dblogs_col"));
const dblogs_error_1 = __importDefault(require("./it/dblogs_error"));
const dblogs_search_1 = __importDefault(require("./it/dblogs_search"));
const dblogs_page_1 = __importDefault(require("./it/dblogs_page"));
const route_dblogs_1 = __importDefault(require("./it/route_dblogs"));
const db_operation_1 = __importDefault(require("./it/db_operation"));
const socialMediaPlan_wip_1 = __importDefault(require("./it/socialMediaPlan_wip"));
const socialMediaPlan_nav_1 = __importDefault(require("./it/socialMediaPlan_nav"));
const socialMediaPlan_dashboard_1 = __importDefault(require("./it/socialMediaPlan_dashboard"));
const socialMediaPlan_stat_1 = __importDefault(require("./it/socialMediaPlan_stat"));
const socialMediaPlan_tab_1 = __importDefault(require("./it/socialMediaPlan_tab"));
const socialMediaPlan_history_1 = __importDefault(require("./it/socialMediaPlan_history"));
const socialMediaPlan_library_1 = __importDefault(require("./it/socialMediaPlan_library"));
const socialMediaPlan_filter_1 = __importDefault(require("./it/socialMediaPlan_filter"));
const socialMediaPlan_drawer_1 = __importDefault(require("./it/socialMediaPlan_drawer"));
const socialMediaPlan_post_1 = __importDefault(require("./it/socialMediaPlan_post"));
const socialMediaPlan_approvalQueue_1 = __importDefault(require("./it/socialMediaPlan_approvalQueue"));
const socialMediaPlan_ai_1 = __importDefault(require("./it/socialMediaPlan_ai"));
const socialMediaPlan_channels_1 = __importDefault(require("./it/socialMediaPlan_channels"));
const socialMediaPlan_analytics_1 = __importDefault(require("./it/socialMediaPlan_analytics"));
const socialMediaPlan_creator_1 = __importDefault(require("./it/socialMediaPlan_creator"));
const socialMediaPlan_brief_1 = __importDefault(require("./it/socialMediaPlan_brief"));
const socialMediaPlan_schedule_1 = __importDefault(require("./it/socialMediaPlan_schedule"));
const socialMediaPlan_step_1 = __importDefault(require("./it/socialMediaPlan_step"));
const whatsapp_settingsList_1 = __importDefault(require("./it/whatsapp_settingsList"));
const whatsapp_settingsForm_1 = __importDefault(require("./it/whatsapp_settingsForm"));
const whatsapp_settings_1 = __importDefault(require("./it/whatsapp_settings"));
const whatsapp_groups_1 = __importDefault(require("./it/whatsapp_groups"));
const whatsapp_commsType_1 = __importDefault(require("./it/whatsapp_commsType"));
const whatsapp_sourceType_1 = __importDefault(require("./it/whatsapp_sourceType"));
const whatsapp_trackLog_1 = __importDefault(require("./it/whatsapp_trackLog"));
const whatsapp_dm_1 = __importDefault(require("./it/whatsapp_dm"));
const whatsapp_dashboard_1 = __importDefault(require("./it/whatsapp_dashboard"));
const activities_panel_1 = __importDefault(require("./it/activities_panel"));
const whatsapp_groupForm_1 = __importDefault(require("./it/whatsapp_groupForm"));
const route_whatsapp_1 = __importDefault(require("./it/route_whatsapp"));
const whatsapp_tabs_1 = __importDefault(require("./it/whatsapp_tabs"));
const whatsapp_threads_1 = __importDefault(require("./it/whatsapp_threads"));
const whatsapp_email_1 = __importDefault(require("./it/whatsapp_email"));
const whatsapp_directMessages_1 = __importDefault(require("./it/whatsapp_directMessages"));
exports.default = {
    ...onboarding_tooltip_1.default,
    ...knowledge_picker_1.default,
    ...app_page_1.default,
    ...app_intext_1.default,
    ...modal_share_1.default,
    ...modal_settings_1.default,
    ...chat_entry_1.default,
    ...user_form_1.default,
    ...slot_goal_1.default,
    ...slot_target_1.default,
    ...slot_format_1.default,
    ...slotData_create_1.default,
    ...slotData_load_1.default,
    ...slotData_form_1.default,
    ...slotData_type_1.default,
    ...app_pagination_1.default,
    ...payment_validation_1.default,
    ...payment_status_1.default,
    ...payment_stripe_1.default,
    ...payment_provider_1.default,
    ...payment_confirmed_1.default,
    ...route_payment_1.default,
    ...payment_search_1.default,
    ...payment_preview_1.default,
    ...user_roles_1.default,
    ...user_grade_1.default,
    ...userGroup_form_1.default,
    ...userGroup_error_1.default,
    ...user_profile_1.default,
    ...company_preview_1.default,
    ...company_tooltips_1.default,
    ...company_form_1.default,
    ...access_status_1.default,
    ...access_list_1.default,
    ...avatar_processing_1.default,
    ...avatar_form_1.default,
    ...webhook_eventTypes_1.default,
    ...webhook_cronIntervals_1.default,
    ...tools_imgGen_1.default,
    ...tools_convoTags_1.default,
    ...tools_galleryTags_1.default,
    ...tools_detectContactData_1.default,
    ...tools_detectTasks_1.default,
    ...tools_productCompare_1.default,
    ...tools_askForVoucher_1.default,
    ...tools_offerCreator_1.default,
    ...tools_quickOffer_1.default,
    ...tools_sendContactForm_1.default,
    ...tools_apiTool_1.default,
    ...tools_productAPISearch_1.default,
    ...tools_dynamicListings_1.default,
    ...tools_productCard_1.default,
    ...tools_personalData_1.default,
    ...tools_rag_1.default,
    ...tools_aiFormAnalyzer_1.default,
    ...avatar_common_1.default,
    ...avatar_active_1.default,
    ...avatar_tooltips_1.default,
    ...avatar_knowledge_1.default,
    ...avatar_preview_1.default,
    ...style_form_1.default,
    ...accountGrade_list_1.default,
    ...accountGrade_form_1.default,
    ...limits_avatar_1.default,
    ...limits_user_1.default,
    ...limits_project_1.default,
    ...limits_knowledge_1.default,
    ...limits_customModel_1.default,
    ...limits_writingStyles_1.default,
    ...limits_advanced_prompts_1.default,
    ...limits_prompt_assist_1.default,
    ...limits_anti_hallucination_1.default,
    ...limits_advanced_reports_1.default,
    ...limits_chat_thread_sharing_1.default,
    ...limits_custom_branding_1.default,
    ...limits_widgets_1.default,
    ...limits_voice_agent_1.default,
    ...limits_upgrade_1.default,
    ...voice_chat_error_1.default,
    ...email_pass_reset_1.default,
    ...email_activation_1.default,
    ...email_upgrade_1.default,
    ...email_payment_1.default,
    ...register_complete_1.default,
    ...password_reset_1.default,
    ...accountGrade_preview_1.default,
    ...table_controls_1.default,
    ...route_settings_1.default,
    ...route_style_1.default,
    ...route_company_1.default,
    ...route_user_1.default,
    ...route_accountGrade_1.default,
    ...route_userGroup_1.default,
    ...route_user_group_1.default,
    ...route_branch_1.default,
    ...route_profession_1.default,
    ...route_avatar_1.default,
    ...route_conversation_1.default,
    ...route_botTest_1.default,
    ...route_tutorial_1.default,
    ...tutorial_create_1.default,
    ...tutorial_edit_1.default,
    ...tutorial_preview_1.default,
    ...tutorial_delete_1.default,
    ...tutorial_list_1.default,
    ...tutorial_start_1.default,
    ...tutorial_new_section_1.default,
    ...tutorial_search_1.default,
    ...tutorial_form_1.default,
    ...tutorial_validation_1.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...tutorial_errors_1.default,
    ...botTest_create_1.default,
    ...botTest_edit_1.default,
    ...botTest_tester_1.default,
    ...botTest_target_1.default,
    ...botTest_list_1.default,
    ...botTest_actions_1.default,
    ...botTest_preview_1.default,
    ...botTest_testResults_1.default,
    ...route_ai_1.default,
    ...ai_models_1.default,
    ...ai_com_1.default,
    ...ai_fields_1.default,
    ...ai_controls_1.default,
    ...ai_assist_suggestions_1.default,
    ...ai_suggestions_1.default,
    ...ai_assist_1.default,
    ...conversation_type_1.default,
    ...conversation_agent_1.default,
    ...conversation_session_1.default,
    ...conversation_avatar_1.default,
    ...conversation_voice_1.default,
    ...conversation_clear_1.default,
    ...conversation_auto_1.default,
    ...conversation_start_1.default,
    ...conversation_stop_1.default,
    ...conversation_recording_1.default,
    ...recording_start_1.default,
    ...recording_process_1.default,
    ...conversation_end_1.default,
    ...message_send_1.default,
    ...microphone_access_1.default,
    ...conversation_interruption_1.default,
    ...conversations_search_1.default,
    ...conversations_date_1.default,
    ...conversations_error_1.default,
    ...conversations_delete_1.default,
    ...conversations_favorite_1.default,
    ...account_upgrade_1.default,
    ...account_grades_1.default,
    ...route_knowledge_1.default,
    ...route_knowledgeProject_1.default,
    ...knowledge_title_1.default,
    ...knowledge_description_1.default,
    ...knowledge_content_1.default,
    ...knowledge_tags_1.default,
    ...knowledge_active_1.default,
    ...knowledge_filter_1.default,
    ...knowledge_project_1.default,
    ...project_form_1.default,
    ...project_name_1.default,
    ...project_description_1.default,
    ...project_icon_1.default,
    ...knowledge_native_1.default,
    ...knowledge_ragStatus_1.default,
    ...knowledge_statusInfo_1.default,
    ...knowledge_form_1.default,
    ...knowledge_bulk_upload_1.default,
    ...knowledge_preview_1.default,
    ...knowledgeProject_form_1.default,
    ...knowledgeProject_name_1.default,
    ...knowledgeProject_description_1.default,
    ...knowledgeProject_icon_1.default,
    ...chat_teaser_1.default,
    ...chat_heading_1.default,
    ...chat_config_1.default,
    ...chat_noCredits_1.default,
    ...file_upload_1.default,
    ...file_clipboard_1.default,
    ...trainer_reset_1.default,
    ...trainer_tab_1.default,
    ...trainer_upload_1.default,
    ...trainer_config_1.default,
    ...chat_sync_1.default,
    ...ai_chat_1.default,
    ...branch_list_1.default,
    ...branch_create_1.default,
    ...branch_edit_1.default,
    ...branch_search_1.default,
    ...branch_delete_1.default,
    ...branch_form_1.default,
    ...profession_list_1.default,
    ...profession_create_1.default,
    ...profession_edit_1.default,
    ...profession_search_1.default,
    ...profession_delete_1.default,
    ...profession_form_1.default,
    ...profession_common_1.default,
    ...step_shared_1.default,
    ...step_list_1.default,
    ...step_create_1.default,
    ...step_edit_1.default,
    ...step_search_1.default,
    ...step_delete_1.default,
    ...step_form_1.default,
    ...question_list_1.default,
    ...question_create_1.default,
    ...question_edit_1.default,
    ...question_search_1.default,
    ...question_delete_1.default,
    ...question_form_1.default,
    ...question_type_1.default,
    ...onboarding_intro_1.default,
    ...onboarding_list_1.default,
    ...onboarding_create_1.default,
    ...onboarding_edit_1.default,
    ...onboarding_search_1.default,
    ...onboarding_delete_1.default,
    ...onboarding_status_1.default,
    ...onboarding_wizard_1.default,
    ...onboarding_benefits_1.default,
    ...onboarding_button_1.default,
    ...onboarding_image_1.default,
    ...onboarding_faq_1.default,
    ...onboarding_setup_1.default,
    ...onboarding_knowledge_1.default,
    ...onboarding_avatar_1.default,
    ...onboarding_profession_1.default,
    ...voices_david_1.default,
    ...voices_bradford_1.default,
    ...voices_clyde_1.default,
    ...voices_natalie_1.default,
    ...voices_jane_1.default,
    ...voices_magdalena_1.default,
    ...onboarding_records_1.default,
    ...onboarding_record_1.default,
    ...onboarding_warning_1.default,
    ...onboarding_step_1.default,
    ...onboarding_questions_1.default,
    ...onboarding_pagination_1.default,
    ...onboarding_progress_1.default,
    ...onboarding_stats_1.default,
    ...onboarding_view_1.default,
    ...onboarding_pick_1.default,
    ...onboarding_error_1.default,
    ...onboarding_success_1.default,
    ...onboarding_notify_1.default,
    ...login_username_1.default,
    ...login_password_1.default,
    ...login_form_1.default,
    ...register_name_1.default,
    ...register_username_1.default,
    ...register_email_1.default,
    ...register_password_1.default,
    ...register_repeat_password_1.default,
    ...register_form_1.default,
    ...register_company_1.default,
    ...activate_hero_1.default,
    ...activate_page_1.default,
    ...activate_loading_1.default,
    ...activate_success_1.default,
    ...activate_error_1.default,
    ...activate_button_1.default,
    ...settings_general_1.default,
    ...settings_socialMedia_1.default,
    ...settings_rag_1.default,
    ...rag_settings_1.default,
    ...settings_credit_1.default,
    ...rag_file_1.default,
    ...settings_googleDrive_1.default,
    ...googleDrive_picker_1.default,
    ...settings_status_1.default,
    ...route_reports_1.default,
    ...reports_access_1.default,
    ...reports_costReports_1.default,
    ...reports_export_1.default,
    ...reports_period_1.default,
    ...chat_settings_1.default,
    ...config_tooltips_1.default,
    ...share_conversation_1.default,
    ...autocomplete_triggers_1.default,
    ...reports_shared_1.default,
    ...acl_table_1.default,
    ...shortcuts_button_1.default,
    ...shortcuts_table_1.default,
    ...shortcuts_knowledge_1.default,
    ...shortcuts_new_1.default,
    ...shortcuts_settings_1.default,
    ...shortcuts_find_1.default,
    ...shortcuts_prompt_1.default,
    ...currency_error_1.default,
    ...nav_avatar_1.default,
    ...nav_model_1.default,
    ...nav_ai_1.default,
    ...googleDrive_directoryPicker_1.default,
    ...knowledge_bulkUpload_1.default,
    ...dblogs_filter_1.default,
    ...dblogs_results_1.default,
    ...dblogs_col_1.default,
    ...dblogs_error_1.default,
    ...dblogs_search_1.default,
    ...dblogs_page_1.default,
    ...route_dblogs_1.default,
    ...db_operation_1.default,
    ...socialMediaPlan_wip_1.default,
    ...socialMediaPlan_nav_1.default,
    ...socialMediaPlan_dashboard_1.default,
    ...socialMediaPlan_stat_1.default,
    ...socialMediaPlan_tab_1.default,
    ...socialMediaPlan_history_1.default,
    ...socialMediaPlan_library_1.default,
    ...socialMediaPlan_filter_1.default,
    ...socialMediaPlan_drawer_1.default,
    ...socialMediaPlan_post_1.default,
    ...socialMediaPlan_approvalQueue_1.default,
    ...socialMediaPlan_ai_1.default,
    ...socialMediaPlan_channels_1.default,
    ...socialMediaPlan_analytics_1.default,
    ...socialMediaPlan_creator_1.default,
    ...socialMediaPlan_brief_1.default,
    ...socialMediaPlan_schedule_1.default,
    ...socialMediaPlan_step_1.default,
    ...whatsapp_settingsList_1.default,
    ...whatsapp_settingsForm_1.default,
    ...whatsapp_settings_1.default,
    ...whatsapp_groups_1.default,
    ...whatsapp_commsType_1.default,
    ...whatsapp_sourceType_1.default,
    ...whatsapp_trackLog_1.default,
    ...whatsapp_dm_1.default,
    ...whatsapp_dashboard_1.default,
    ...activities_panel_1.default,
    ...whatsapp_groupForm_1.default,
    ...route_whatsapp_1.default,
    ...whatsapp_tabs_1.default,
    ...whatsapp_threads_1.default,
    ...whatsapp_email_1.default,
    ...whatsapp_directMessages_1.default,
    ...it_2.default,
    'app.name': "IntHub",
    'acl_resource.knowledge_group': 'Gruppo di Conoscenza',
    'acl_resource.payment': 'Pagamento',
    'acl_resource.botTest': 'Test Bot',
    'app.removed': 'Rimosso',
    'app.share': 'Condividi',
    'app.share_link': 'Condividi link',
    'app.co_share': 'Condividi con utenti',
    // Modal headers
    // Chat
    'profile': 'Profilo',
    'messages': 'Messaggi',
    'logout': 'Disconnetti',
    'lang.en': 'EN',
    'lang.de': 'Tedesco',
    'lang.es': 'Spagnolo',
    'lang.it': 'Italiano',
    'lang.pl': 'Polacco',
    'lang.zh': 'Cinese',
    // User form language fields
    // Opzioni slot
    'slot.none': 'Nessuno',
    // Slot placeholders
    'slot.prompt_context': 'Argomento',
    'slot.conversation_goal': 'Obiettivo conversazione',
    'slot.conversation_target': 'Pubblico target',
    'slot.conversation_format': 'Formato output',
    // Slot data management
    'slot-data.created': 'Dati slot creati con successo',
    'slot-data.deleted': 'Dati slot eliminati con successo',
    'pagination.itemsPerPage': 'Elementi per pagina',
    'pagination.ellipsis': '…',
    'search.placeholder': 'Cerca...',
    'search.clear': 'Cancella ricerca',
    'crud.create': 'Crea',
    'crud.edit': 'Modifica',
    'crud.delete': 'Elimina',
    'crud.preview': 'Anteprima',
    'crud.saving': 'Salvando...',
    'crud.filtering': 'Filtraggio',
    'crud.searchPlaceholder': 'Cerca...',
    'crud.noCompanies': 'Nessuna azienda trovata',
    'crud.noEntries': 'Nessuna voce trovata',
    'crud.failedToLoad': 'Impossibile caricare i dati',
    'crud.confirmDelete': 'Sei sicuro di voler eliminare',
    'crud.deletedSuccessfully': 'Eliminato con successo',
    'crud.failedToDelete': 'Impossibile eliminare',
    // Form operations
    'form.back': 'Indietro',
    // Common status terms
    'common.yes': 'Sì',
    'common.no': 'No',
    'common.active': 'Attivo',
    'common.inactive': 'Inattivo',
    'common.common': 'Comune',
    'common.ordering': 'Ordinamento',
    'common.createdAt': 'Creato Il',
    // Payment
    'payment.gateway': 'Gateway di Pagamento',
    'payment.provider': 'Fornitore di Pagamenti',
    'payment.amount': 'Importo',
    'payment.description': 'Descrizione',
    'payment.sessionId': 'ID Sessione',
    'payment.id': 'ID Pagamento',
    'payment.status': 'Stato del Pagamento',
    'payment.currentStatus': 'Stato Attuale',
    'payment.initiate': 'Inizia Pagamento',
    'payment.testConnection': 'Testa Connessione',
    'payment.refreshStatus': 'Aggiorna Stato',
    'payment.reset': 'Reimposta Pagamento',
    'payment.defaultDescription': 'Transazione di pagamento',
    'payment.initialized': 'Pagamento inizializzato con successo',
    'payment.initializationFailed': 'Inizializzazione pagamento fallita',
    'payment.successful': 'Pagamento completato con successo',
    'payment.pending': 'Pagamento in attesa',
    'payment.rejected': 'Pagamento rifiutato',
    'payment.error': 'Si è verificato un errore di pagamento',
    'payment.connectionSuccessful': 'Connessione al fornitore di pagamenti riuscita',
    'payment.connectionFailed': 'Connessione al fornitore di pagamenti fallita',
    'payment.statusCheckFailed': 'Controllo dello stato del pagamento fallito',
    'payment.noPaymentId': 'Nessun ID pagamento disponibile',
    'payment.processing': 'Elaborazione...',
    'payment.confirmationFailed': 'Conferma del pagamento fallita',
    'payment.unsupportedProvider': 'Fornitore di pagamento non supportato',
    'payment.selectProvider': 'Seleziona Fornitore di Pagamento',
    'payment.operationName': 'Operazione di Pagamento',
    // Payment List & Preview
    'payment.user': 'Utente',
    'payment.email': 'Email',
    'payment.targetGrade': 'Grado Target',
    'payment.paidAt': 'Pagato Il',
    'payment.failureReason': 'Motivo del Fallimento',
    'payment.details': 'Dettagli Pagamento',
    'payment.timeline': 'Timeline',
    'payment.created': 'Creato',
    'payment.updated': 'Aggiornato',
    'payment.technicalDetails': 'Dettagli Tecnici',
    'payment.stripePaymentIntentId': 'ID Intenzione Pagamento Stripe',
    'payment.stripeCustomerId': 'ID Cliente Stripe',
    'payment.orderId': 'ID Ordine',
    'payment.metadata': 'Metadati',
    // Gender
    'gender.male': 'Maschio',
    'gender.female': 'Femmina',
    'searchUser.users': 'Utenti',
    'searchUser.searchPlaceholder': 'Cerca utenti...',
    'searchUser.selectedParticipants': 'Partecipanti selezionati',
    'searchUser.availableUsers': 'Utenti disponibili',
    'searchUser.noUsersFound': 'Nessun utente trovato.',
    'searchUser.failedToLoadUsers': 'Impossibile caricare gli utenti',
    'user.name': 'Nome',
    'user.last_name': 'Cognome',
    'user.username': 'Nome utente',
    'user.email': 'Email',
    'user.parent': 'Utente principale',
    'user.role': 'Ruolo',
    'user.status': 'Stato',
    'user.company': 'Azienda',
    'user.listTitle': 'Utenti',
    'user.addUser': 'Aggiungi utente',
    'user.searchPlaceholder': 'Cerca utenti...',
    // User list component (for non-admin users)
    'userList.title': 'Membri del Team',
    'userList.description': 'Connettiti e collabora con i membri del tuo team',
    'userList.searchPlaceholder': 'Cerca membri del team...',
    'userList.noUsers': 'Nessun membro del team trovato',
    'userList.loading': 'Caricamento membri del team...',
    'userList.online': 'Online',
    'userList.offline': 'Offline',
    'userList.lastSeen': 'Visto l\'ultima volta',
    'userList.startChat': 'Inizia Chat',
    'userList.viewProfile': 'Visualizza Profilo',
    // User Group List Columns
    'userGroup.name': 'Nome',
    'userGroup.description': 'Descrizione',
    'userGroup.active': 'Attivo',
    'userGroup.owner': 'Proprietario',
    'userGroup.userCount': 'Numero di Utenti',
    // User Group list page
    'userGroup.listTitle': 'Gruppi di Utenti',
    'userGroup.addUserGroup': 'Aggiungi Gruppo di Utenti',
    'userGroup.searchPlaceholder': 'Cerca gruppi di utenti...',
    // User Group form page
    'userGroup.create': 'Crea Gruppo di Utenti',
    // User form
    // User form preview
    // User form errors
    // User profile
    'company.name': 'Nome',
    'company.nip': 'P.IVA',
    'company.email': 'Email',
    'company.phone': 'Telefono',
    'company.city': 'Città',
    'company.address': 'Indirizzo',
    'company.street': 'Via',
    'company.postalCode': 'CAP',
    'company.website': 'Sito Web',
    'company.description': 'Descrizione',
    'company.modules': 'Moduli',
    'company.active': 'Attiva',
    // Company Preview & Tooltips
    // Company form
    'access.user_or_company': 'Utente / Azienda',
    'access.user_group': 'Gruppo Utente',
    'access.policies': 'Politiche di accesso',
    'access.active': 'Attivo',
    'avatar.image': 'Immagine',
    'avatar.name': 'Nome',
    'avatar.gender': 'Genere',
    'avatar.age': 'Età',
    'avatar.model': 'Modello',
    'avatar.onboarded': 'Introdotto',
    'avatar.processing': 'Elaborazione',
    'avatar.avatar': 'Avatar',
    'avatar.description': 'Descrizione',
    'avatar.listTitle': 'Assistenti',
    'avatar.noAvatars': 'Nessun assistente trovato',
    'avatar.addAvatar': 'Aggiungi Assistente',
    'avatar.searchPlaceholder': 'Cerca assistente...',
    'avatar.listView': 'Vista Elenco',
    'avatar.gridView': 'Vista Griglia',
    // Avatar form knowledge section
    // Avatar form page
    // Configurazione webhooks
    // Definizioni webhooks
    // Esempi di payload webhook
    // Tipi di eventi webhook
    // Azioni conoscenza
    'knowledge.edit': 'Modifica Conoscenza',
    // Intervalli cron webhook
    // Configurazione lessico
    // Strumenti API
    'apiTool.requestSent': 'Richiesta inviata',
    'apiTool.requestFailed': 'Richiesta fallita',
    'apiTool.collectingData': 'Raccolta dati...',
    'apiTool.response': 'Risposta',
    'apiTool.noData': 'Nessun dato di richiesta API',
    'tools.productCard': 'Schede Prodotto',
    'avatar.creator': 'Creatore',
    'avatar.voiceAgent': 'Agente Vocale',
    'avatar.common': 'Avatar Comune',
    'avatar.active': 'Attivo',
    'avatar.cantEditCommon': 'Non è possibile modificare avatar comuni. Solo i super amministratori possono modificare avatar comuni.',
    'avatar.cantDeleteCommon': 'Non è possibile eliminare avatar comuni. Solo i super amministratori possono eliminare avatar comuni.',
    // Avatar tooltips
    // Avatar knowledge management
    // Avatar preview page
    // Style List Columns
    'style.name': 'Nome',
    'style.description': 'Descrizione',
    'style.prompt': 'Prompt',
    'style.common': 'Stile Comune',
    'style.active': 'Attivo',
    'style.style': 'Stile',
    // Style list page
    'style.listTitle': 'Stili di Scrittura',
    'style.addStyle': 'Aggiungi Stile di Scrittura',
    'style.searchPlaceholder': 'Cerca stili...',
    // Style form page
    'style.updated': 'aggiornato',
    'style.created': 'creato',
    'style.update': 'aggiorna',
    'style.create': 'crea',
    // Pacchetti Prezzo List Columns
    'accountGrade.name': 'Nome',
    'accountGrade.description': 'Descrizione',
    'accountGrade.advancedPrompts': 'Prompt Avanzati',
    'accountGrade.promptAssist': 'Assistente Prompt',
    'accountGrade.maxAvatars': 'Max. Avatar',
    'accountGrade.maxUsers': 'Max. Utenti',
    'accountGrade.maxProjectsCount': 'Max. Progetti',
    'accountGrade.maxKnowledgeEntries': 'Max. Conoscenza',
    'accountGrade.antiHallucination': 'Anti-Allucinazione',
    'accountGrade.advancedReports': 'Report Avanzati',
    'accountGrade.chatThreadSharing': 'Condivisione Thread Chat',
    'accountGrade.customBranding': 'Branding Personalizzato',
    'accountGrade.widgets': 'Widget',
    'accountGrade.customAiModels': 'Modelli AI Personalizzati',
    'accountGrade.voiceAgent': 'Agente Vocale',
    'accountGrade.writingStyles': 'Stili di Scrittura',
    'accountGrade.price': 'Prezzo',
    'accountGrade.creditsPerMonth': 'Crediti al Mese',
    'accountGrade.active': 'Attivo',
    'accountGrade.order': 'Ordine',
    // Pacchetti Prezzo list page
    'accountGrade.listTitle': 'Pacchetti Prezzo',
    'accountGrade.noAccountGrades': 'Nessun pacchetto prezzo trovato',
    'accountGrade.noResults': 'Nessun pacchetto prezzo trovato',
    'accountGrade.addAccountGrade': 'Aggiungi Pacchetto Prezzo',
    'accountGrade.add': 'Aggiungi Pacchetto Prezzo',
    'accountGrade.createTitle': 'Crea Pacchetto Prezzo',
    'accountGrade.searchPlaceholder': 'Cerca pacchetto prezzo...',
    // Pacchetti Prezzo form page
    // Pacchetti Prezzo sections
    'accountGrade.previewTitle': 'Il tuo piano',
    'accountGrade.basicInfo': 'Informazioni di Base',
    'accountGrade.features': 'Funzionalità',
    'accountGrade.status': 'Stato',
    'accountGrade.limits': 'Limiti',
    'accountGrade.unlimited': 'Illimitato',
    // Account limits and restrictions
    'limits.noAccountGrade': 'Piano account non trovato. Si prega di contattare il supporto.',
    // Voice chat errors
    // Email translations
    // Account upgrade emails
    // Payment success emails
    // Payment failed emails
    // Common payment fields
    // Registration completion
    // Password Reset Page
    // Password Reset Confirm Page
    // Pacchetti Prezzo preview page
    'chatDemo.title': 'Demo Sistema Chat',
    'chatDemo.intro': 'È stato implementato un sistema completo di cronologia delle conversazioni.',
    'chatDemo.featuresTitle': 'Funzionalità implementate:',
    'chatDemo.openChat': 'Apri Sistema Chat',
    'chatDemo.implementationTitle': 'Dettagli implementazione:',
    'chatDemo.backendModels': 'Modelli backend:',
    'chatDemo.apiEndpoints': 'Endpoint API:',
    'chatDemo.frontendComponents': 'Componenti frontend:',
    'home.dashboardArea': 'AREA DASHBOARD',
    'form.label': 'Etichetta',
    'form.value': 'Valore',
    'form.required': 'Obbligatorio',
    'form.optional': 'Opzionale',
    'login.usernameLabel': 'Login/Email',
    'login.passwordLabel': 'Password',
    'login.forgotPassword': 'Password dimenticata?',
    'login.submit': 'Accedi',
    'register.nameLabel': 'Nome',
    'register.lastNameLabel': 'Cognome',
    'register.usernameLabel': 'Login',
    'register.emailLabel': 'E-mail',
    'register.passwordLabel': 'Password',
    'register.repeatPasswordLabel': 'Ripeti Password',
    'register.submit': 'Registrati',
    // Route translations
    'route.dashboard': 'Pannello',
    'route.companyManagement': 'Gestione Aziende',
    'route.settings': 'Impostazioni',
    'route.register': 'Registrazione',
    'route.profile': 'Profilo',
    'route.team': 'Team',
    'route.assistants': 'Assistenti',
    // Style routes
    'route.styles': 'Stili di Scrittura',
    // Routes
    'route.conversations': 'Conversazioni',
    'route.conversationList': 'Conversazioni',
    'route.conversationPreview': 'Anteprima Conversazione',
    'tutorial.noDescription': 'Nessuna descrizione disponibile',
    'tutorial.steps': 'passaggi',
    'tutorial.sections': 'sezioni',
    'tutorial.noTasks': 'Nessun compito disponibile per questa sezione',
    'tutorial.created': 'Tutorial creato con successo',
    'tutorial.updated': 'Tutorial aggiornato con successo',
    'tutorial.saveFailed': 'Impossibile salvare il tutorial',
    'tutorial.loadFailed': 'Impossibile caricare il tutorial',
    'tutorial.loadListFailed': 'Impossibile caricare i tutorial',
    'tutorial.deleteFailed': 'Impossibile eliminare il tutorial',
    // Form-related translations
    // Error messages
    // Additional validation messages
    'botTest.title': 'Test Bot',
    'botTest.name': 'Nome del Test',
    'botTest.date': 'Data',
    'botTest.testDate': 'Data del Test',
    'botTest.description': 'Descrizione',
    'botTest.testers': 'Tester',
    'botTest.targets': 'Obiettivi',
    'botTest.messages': 'messaggi',
    'botTest.noTesters': 'Nessun tester disponibile da eseguire',
    'botTest.addTester': 'Aggiungi Tester',
    'botTest.addTarget': 'Aggiungi Obiettivo',
    'botTest.model': 'Modello',
    // Bot Test Preview
    // Bot Test Preview Tabs
    // Bot Test Results
    // Bot Test Results
    'route.ai': 'Chat IA',
    'ai-assist.header': 'Assistente IA',
    'ai-assist.minimize': 'Riduci',
    'ai-assist.expand': 'Espandi',
    'ai-assist.info': 'L\'assistente IA analizzerà i tuoi prompt e conversazioni e fornirà suggerimenti per aiutare a ottenere risultati migliori. Puoi disabilitarlo nelle impostazioni della chat nell\'angolo in basso a destra dell\'area di input della chat',
    'ai-assist.no-entries': 'Inizia una conversazione per attivare l\'aiuto dell\'assistente IA',
    'modelSelect.instruction': 'Scegli il tuo avatar o modello IA con cui vuoi parlare',
    'modelSelect.knowledgeCreatingInProgress': 'Creazione voce database conoscenza in corso...',
    // AI Suggestions Component
    // AI Assist Component
    // Model Select Component
    'modelSelect.models': 'Modelli',
    'modelSelect.avatars': 'Avatar',
    'modelSelect.liveChats': 'Chat dal Vivo',
    'modelSelect.voiceModels': 'Modelli Vocali',
    // Traduzioni conversazioni
    'conversation.demo': 'Agente Vocale',
    'conversation.agent': 'Agente',
    'conversation.connected': 'Connesso',
    'conversation.disconnected': 'Disconnesso',
    'conversation.connecting': 'Connessione in corso...',
    'conversation.voice': 'Voce',
    'conversation.you': 'Tu',
    'conversation.send': 'Invia',
    'conversation_agent.first_word': 'Ciao! Come posso aiutarti oggi?',
    'conversation.volume': 'Volume',
    'conversation.debug': 'Informazioni di Debug',
    'conversation.language': 'Lingua',
    'conversation.messages': 'Messaggi',
    'conversation.started': 'Conversazione avviata con successo!',
    'conversation.ended': 'Conversazione terminata.',
    'conversation.error': 'Si è verificato un errore durante la conversazione.',
    'conversation.start': 'Avvia Conversazione',
    'conversation.end': 'Termina Conversazione',
    'recording.start': 'Avvia Registrazione',
    'recording.stop': 'Ferma Registrazione',
    'message.used_tools': 'Strumenti Utilizzati',
    'conversations.title': 'Conversazioni',
    'conversations.loading': 'Caricamento conversazioni...',
    'conversations.retry': 'Riprova',
    'conversations.empty': 'Nessuna conversazione trovata',
    'conversations.chat_history': 'Cronologia Chat',
    'conversations.no_conversations_yet': 'Nessuna conversazione ancora',
    'conversations.no_messages_yet': 'Nessun messaggio ancora',
    'conversations.loading_more': 'Caricamento ulteriori...',
    'conversations.no_more_conversations': 'Nessuna altra conversazione',
    'conversations.avatar': 'Avatar',
    'conversations.new_chat': 'Nuovo Thread',
    // Azioni comuni
    'common.create': 'Crea',
    'common.update': 'Aggiorna',
    'common.cancel': 'Annulla',
    'common.close': 'Chiudi',
    'common.back': 'Indietro',
    'common.clear': 'Cancella',
    'common.moveUp': 'Sposta su',
    'common.moveDown': 'Sposta giù',
    'common.delete': 'Elimina',
    'common.optional': '(Opzionale)',
    'common.none': 'Nessuno',
    'common.pay': 'Paga',
    'common.loading': 'Caricamento...',
    'common.showing': 'Mostrando',
    'common.to': 'a',
    'common.of': 'di',
    'common.next': 'Successivo',
    'common.previous': 'Precedente',
    'common.apply': 'Applica',
    'common.results': 'risultati',
    'common.hide': 'Nascondi',
    // Gestione account
    // Livelli account
    // Percorsi conoscenza
    // Traduzioni conoscenza
    'knowledge.create': 'Crea conoscenza',
    'knowledge.title': 'Titolo',
    'knowledge.description': 'Descrizione',
    'knowledge.content': 'Contenuto',
    'knowledge.file': 'File',
    'knowledge.tags': 'Tag',
    'knowledge.project': 'Progetto',
    'knowledge.no_group': 'Nessun gruppo',
    'knowledge.no_project': 'Nessun progetto',
    'knowledge.active': 'Attivo',
    // Project translations
    'project.manage': 'Gestisci progetti',
    'project.none': 'Nessun progetto',
    'project.name': 'Nome progetto',
    'project.description': 'Descrizione',
    'project.color': 'Colore',
    'project.icon': 'Icona',
    'project.isActive': 'Attivo',
    'project.preview': 'Anteprima',
    'project.list': 'Progetti',
    'project.create': 'Aggiungi progetto',
    'project.edit': 'Modifica progetto',
    'project.creator': 'Creatore',
    'knowledge.native': 'Conoscenza Nativa',
    'knowledge.creator': 'Creatore',
    'knowledge.ragStatus': 'Stato RAG',
    'knowledge.assigned': 'Assegnato',
    'knowledge.createdAt': 'Creato il',
    // RAG Status Values
    'knowledge.reindex': 'Ri-indicizzare',
    'knowledge.reindexingStarted': 'La ri-indicizzazione è stata avviata',
    // Traduzioni modulo conoscenza
    // Traduzioni caricamento massivo conoscenza
    // Google Drive bulk upload
    // Google Drive bulk upload info
    // Knowledge preview
    'knowledge.preview': 'Anteprima Conoscenza',
    // Knowledge preview sections
    // Knowledge preview content type labels
    // Knowledge preview RAG status labels
    // Knowledge preview active status
    // Knowledge preview usage
    // Traduzioni progetti
    // Project form
    // Project general
    'knowledgeProject.name': 'Nome progetto',
    'knowledgeProject.description': 'Descrizione',
    'knowledgeProject.color': 'Colore',
    'knowledgeProject.icon': 'Icona',
    'knowledgeProject.isActive': 'Attivo',
    'knowledgeProject.preview': 'Anteprima',
    'knowledgeProject.list': 'Progetti',
    'knowledgeProject.create': 'Aggiungi progetto',
    // Chat component translations
    'file.ext': 'tipo di file',
    'file.size': 'dimensione del file',
    // LLM Trainer
    'trainer.title': 'Addestratore di Modello LLM',
    "trainer.listTitle": "Elenco Formatori",
    "trainer.jobId": "ID Lavoro",
    "trainer.modelName": "Nome Modello",
    "trainer.trainingType": "Tipo di Addestramento",
    "trainer.status": "Stato",
    "trainer.createdAt": "Creato il",
    "trainer.updatedAt": "Aggiornato il",
    "trainer.addJob": "Aggiungi Lavoro",
    // Upload Component
    // Manual Entry
    // PDF Processing
    // Trainer config
    // Messaggi popup
    'popup.error': 'Errore',
    'popup.alert': 'Avviso',
    'popup.confirm': 'Conferma',
    'popup.ok': 'OK',
    'popup.yes': 'Sì',
    'popup.no': 'No',
    "training_jobs.list": "Elenco lavori di addestramento",
    // CodeViewerComponent translations
    'code-viewer.show_code': 'Mostra codice',
    'code-viewer.hide_code': 'Nascondi codice',
    'code-viewer.writing_code': 'Scrivendo codice',
    // Branch translations
    'route.branches': 'Settori',
    'branch.name': 'Nome',
    'branch.description': 'Descrizione',
    'branch.color': 'Colore',
    'branch.create': 'Crea Settore',
    // Branch form page
    'branch.form.error.load_failed': "Errore nel caricamento del settore",
    'branch.form.error.action_failed': "Azione fallita",
    'branch.form.error.general_error': "Si è verificato un errore",
    'branch.form.action.updated': "aggiornato",
    'branch.form.action.created': "creato",
    'branch.form.action.update': "aggiornare",
    'branch.form.action.create': "creare",
    'branch.form.success.updated': "Settore aggiornato con successo",
    'branch.form.success.created': "Settore creato con successo",
    'branch.form.success.action_completed': "Azione completata",
    // Profession translations
    'route.professions': 'Professioni',
    'profession.name': 'Nome',
    'profession.description': 'Descrizione',
    'profession.branch': 'Settore',
    'profession.create': 'Crea Professione',
    'profession.common': 'Comune',
    'profession.creator': 'Creatore',
    // Step translations
    'route.steps': 'Passi',
    'step.title': 'Titolo',
    'step.description': 'Descrizione',
    'step.order': 'Ordine',
    'step.isShared': 'Condiviso',
    'step.profession': 'Professione',
    'step.create': 'Crea Passo',
    // Step form page
    // Question translations
    'route.questions': 'Domande',
    'question.title': 'Titolo',
    'question.description': 'Descrizione',
    'question.type': 'Tipo',
    'question.required': 'Richiesto',
    'question.order': 'Ordine',
    'question.step': 'Passo',
    'question.create': 'Crea Domanda',
    // Question form (question manager)
    // Question types
    // Onboarding translations
    'route.onboardings': 'Onboarding',
    // Onboarding intro
    'onboarding.avatar': 'Avatar',
    'onboarding.profession': 'Professione',
    'onboarding.status': 'Stato',
    'onboarding.currentStep': 'Passo Corrente',
    'onboarding.createdAt': 'Creato',
    'onboarding.create': 'Inizia Onboarding',
    // Onboarding Wizard translations
    // Onboarding Component
    'onboarding.title': 'Onboarding',
    'onboarding.loading': 'Caricamento...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    'knowledge': 'conoscenza',
    // Additional onboarding translations
    'onboarding.filter': 'Filtra',
    'onboarding.progress': 'Progresso',
    'onboarding.createdBy': 'Creato da',
    'pagination.previous': 'Precedente',
    'pagination.next': 'Successivo',
    'actions': 'Azioni',
    'view': 'Visualizza',
    'edit': 'Modifica',
    'delete': 'Elimina',
    'loading': 'Caricamento...',
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': 'campi completati',
    // Missing login/register keys not in main section
    // Registration Complete page   
    // Account Activation page
    // Settings translations
    'settings.saveButton': 'Salva Impostazioni',
    'settings.savedSuccessfully': 'Impostazioni salvate con successo',
    'settings.failedToSave': 'Errore nel salvare le impostazioni',
    'settings.failedToLoad': 'Errore nel caricare le impostazioni',
    // Settings Tabs
    // General Settings - Chat Learning
    // RAG Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // Google Drive Settings
    // Google Drive File Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Resource translations
    'resource.active': 'Attivo',
    // Generated Image Component
    'gen-image.noData': 'Nessun dato immagine fornito',
    'gen-image.invalidData': 'Formato dati immagine non valido',
    'gen-image.loadError': 'Errore nel caricamento dell\'immagine',
    'gen-image.loading': 'Caricamento immagine...',
    'gen-image.altText': 'Immagine generata',
    'gen-image.download': 'Scarica',
    'gen-image.copyToClipboard': 'Copia negli appunti',
    // File Card Component
    'file-card.errorLoading': 'Errore nel caricamento del file',
    'file-card.unknownFile': 'File sconosciuto',
    'file-card.unknownSize': 'Dimensione sconosciuta',
    'file-card.download': 'Scarica',
    'file-card.addToKdb': 'Aggiungi alla Base di Conoscenza',
    'file-card.videoNotSupported': 'Il tuo browser non supporta il tag video.',
    'file-card.zoomHint': 'clicca per ingrandire',
    'file-card.zoom': 'Ingrandisci',
    'file-card.close': 'Chiudi',
    // Reports routes
    // Reports and Cost Analytics
    'reports.totalCost': 'Costo Totale',
    'reports.totalMessages': 'Messaggi Totali',
    'reports.avgCostPerMessage': 'Costo Medio/Messaggio',
    'reports.totalTokens': 'Token Totali',
    'reports.filters': 'Filtri',
    'reports.startDate': 'Data di Inizio',
    'reports.endDate': 'Data di Fine',
    'reports.minCost': 'Costo Minimo',
    'reports.maxCost': 'Costo Massimo',
    'reports.userName': 'Nome Utente',
    'reports.companyName': 'Nome Azienda',
    'reports.userNamePlaceholder': 'Filtra per nome utente...',
    'reports.companyNamePlaceholder': 'Filtra per nome azienda...',
    'reports.avatarNamePlaceholder': 'Filtra per nome avatar...',
    'reports.date': 'Data',
    'reports.promptTokens': 'Token del Prompt',
    'reports.completionTokens': 'Token di Completamento',
    'reports.cost': 'Costo',
    'reports.cost_type': 'Tipo di Query',
    'reports.company': 'Azienda',
    'reports.upstreamCost': 'Costo Upstream',
    'reports.reasoningTokens': 'Token di Ragionamento',
    'reports.cachedTokens': 'Token in Cache',
    'reports.noData': 'Nessun dato sui costi disponibile',
    'reports.noDataDescription': 'Nessun dato sui costi di utilizzo trovato per i criteri selezionati.',
    'reports.failedToLoad': 'Errore nel caricamento dei dati sui costi',
    'reports.loadingError': 'Errore nel caricamento dei dati sui costi',
    'reports.user': 'Utente',
    'reports.costTrends': 'Tendenze di Costi e Token',
    'reports.showChart': 'Mostra Grafico',
    'reports.tokens': 'Token',
    'report.usage_cost_data': 'Dati sui Costi di Utilizzo',
    'reports.userSummary': 'Statistiche Riassuntive Utenti',
    'reports.messageCount': 'Messaggi',
    'reports.avatarUsage': 'Statistiche di Utilizzo Avatar',
    'reports.avgTokensPerMessage': 'Token Medi/Messaggio',
    'reports.firstUsage': 'Primo Utilizzo',
    'reports.lastUsage': 'Ultimo Utilizzo',
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': 'La scansione completa del documento metterà l\'intero file nel prompt, risultando in risposte più costose e lunghe',
    // Share Conversation
    // AI Assistant Context
    'context.userMessages': 'messaggi utente',
    'context.assistantMessages': 'messaggi assistente',
    'context.activeEntries': 'voci attive',
    'context.summary': 'Contesto',
    'context.empty': 'Nessun contesto disponibile',
    'context.validationError': 'Errore di validazione del contesto',
    // Autocomplete Triggers Component
    // Rapporti
    'and': 'e',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': 'Gestire le impostazioni e le informazioni dell\'azienda',
    'acl_resource_desc.user': 'Gestire gli account utente e i profili',
    'acl_resource_desc.user_group': 'Gestire i gruppi di utenti e le loro autorizzazioni',
    'acl_resource_desc.settings_general': 'Accesso alle impostazioni generali dell\'applicazione',
    'acl_resource_desc.settings_access': 'Gestire il controllo degli accessi e le impostazioni di sicurezza',
    'acl_resource_desc.settings_styles': 'Gestire stili di scrittura e modelli',
    'acl_resource_desc.avatar': 'Creare e gestire avatar AI e assistenti',
    'acl_resource_desc.ai': 'Accesso ai modelli AI e alle configurazioni',
    'acl_resource_desc.knowledge': 'Gestire la base di conoscenze e le risorse informative',
    'acl_resource_desc.project': 'Creare e gestire progetti e flussi di lavoro',
    'acl_resource_desc.onboarding': 'Gestire i processi di onboarding degli utenti e i modelli',
    'acl_resource_desc.reports': 'Generare e visualizzare report di sistema e analisi',
    // ACL Action Descriptions
    'acl_action_desc.read': 'Visualizzare e accedere alle informazioni senza apportare modifiche',
    'acl_action_desc.write': 'Creare, modificare e cambiare contenuti e impostazioni',
    'acl_action_desc.delete': 'Rimuovere ed eliminare definitivamente elementi dal sistema',
    // V-Select Component
    'v-select.createNew': 'Crea nuovo',
    'v-select.noOptions': 'Nessuna opzione disponibile',
    // Keyboard shortcuts
    'shortcuts.title': 'Scorciatoie da Tastiera',
    'shortcuts.tooltip-text': 'Visualizza scorciatoie da tastiera disponibili',
    // Routes
    'route.passwordReset': 'Reimposta Password',
    'route.passwordResetConfirm': 'Reimposta Password',
    'route.registerComplete': 'Registrazione Completata',
    'route.activateAccount': 'Attiva Account',
    // Currency
    // Navigation
    'nav.credits': 'Crediti',
    // Tools
    'tools.toolLabel': 'Strumento',
    'tools.activeTools': 'Strumenti Attivi',
    'tools.expandAll': 'Espandi Tutto',
    'tools.collapseAll': 'Comprimi Tutto',
    'tools.unknownTool': 'Strumento sconosciuto',
    'tools.noActiveTools': 'Nessuno strumento attivo',
    'tools.webSearch': 'Ricerca Web',
    'tools.rag': 'Base di Conoscenza',
    'webSearch.searching': 'Ricerca nel web per',
    'webSearch.toolData': 'Dati di Ricerca Web',
    'webSearch.searchingFor': 'Ricerca per',
    'webSearch.resultsFound': 'risultati trovati',
    'webSearch.noResultsFound': 'Nessun risultato trovato',
    'webSearch.tryDifferentQuery': 'Prova con una query diversa',
    'rag.searchingKnowledge': 'Ricerca nella base di conoscenza',
    'rag.open_knowledge_preview': 'Apri anteprima conoscenza',
    'rag.openInKnowledgeBase': 'Anteprima',
    'rag.noFilesIncluded': 'Nessun file incluso',
    'rag.sources_used': 'Fonti utilizzate',
    'rag.sources': 'Fonti',
    'rag.open_sources': 'Visualizza fonti',
    // Product Cards
    'productCard.toolData': 'Schede Prodotto',
    'productCard.productList': 'Lista Prodotti',
    'productCard.singleProduct': 'Prodotto Singolo',
    'productCard.product': 'prodotto',
    'productCard.products': 'prodotti',
    'productCard.grossPrice': 'Prezzo Lordo',
    'productCard.netPrice': 'Prezzo Netto',
    'productCard.vat': 'IVA',
    'productCard.category': 'Categoria',
    'productCard.viewProduct': 'Visualizza Prodotto',
    'productCard.noProducts': 'Nessun prodotto trovato',
    'productCard.trySearching': 'Prova a cercare prodotti',
    // Product Compare Tool
    'productCompare.domain': 'Dominio',
    'productCompare.comparing': 'Confronto',
    'productCompare.searchQuery': 'Query di ricerca',
    'productCompare.noResults': 'Nessun risultato di confronto trovato',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': 'Numeri di telefono',
    'detectContactData.emails': 'Email',
    'detectContactData.addresses': 'Indirizzi',
    'detectContactData.names': 'Nomi',
    'detectContactData.companies': 'Aziende',
    'detectContactData.socialMedia': 'Social media',
    'detectContactData.websites': 'Siti web',
    'detectContactData.other': 'Altro',
    'detectContactData.noData': 'Nessun dato di contatto rilevato',
    // Detect Tasks Tool
    'detectTasks.notes': 'Note',
    'detectTasks.noTasks': 'Nessun compito rilevato',
    // Offer Creator Tool
    'offerCreator.companyName': 'Nome azienda',
    'offerCreator.firstName': 'Nome',
    'offerCreator.lastName': 'Cognome',
    'offerCreator.email': 'Email',
    'offerCreator.phone': 'Telefono',
    'offerCreator.vatPayer': 'Contribuente IVA',
    'offerCreator.employeesNumber': 'Numero dipendenti',
    'offerCreator.businessActivity': 'Attività commerciale',
    'offerCreator.taxationType': 'Tipo di tassazione',
    'offerCreator.documentsNumber': 'Numero documenti',
    'offerCreator.packageId': 'Pacchetto',
    'offerCreator.additionalInfo': 'Informazioni aggiuntive',
    'offerCreator.formSent': 'Modulo inviato',
    'offerCreator.noData': 'Nessun dato offerta raccolto',
    // Quick Offer Tool
    'quickOffer.availableOptions': 'Opzioni disponibili',
    'quickOffer.formSent': 'Modulo inviato',
    'quickOffer.noFields': 'Nessun campo modulo',
    // Send Contact Form Tool
    'sendContactForm.name': 'Nome',
    'sendContactForm.email': 'Email',
    'sendContactForm.phone': 'Telefono',
    'sendContactForm.message': 'Messaggio',
    'sendContactForm.formSent': 'Modulo contatto inviato',
    'sendContactForm.noData': 'Nessun dato modulo contatto',
    // Conversation Tags Tool
    'convoTags.noTags': 'Nessun tag rilevato',
    // Gallery Tags Tool
    'galleryTags.noTags': 'Nessun tag galleria rilevato',
    // Ask For Voucher Tool
    'askForVoucher.detected': 'Richiesta voucher rilevata',
    'askForVoucher.notDetected': 'Nessuna richiesta voucher rilevata',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': 'annunci segnalati',
    'dynamicListings.allListings': 'Tutti gli annunci segnalati',
    // Product API Search Tool
    'productAPISearch.searchQuery': 'Query di ricerca',
    'productAPISearch.totalResults': 'risultati totali',
    'productAPISearch.subcategories': 'sottocategorie',
    'productAPISearch.noResults': 'Nessun risultato trovato',
    // Google Drive
    // Knowledge Bulk Upload
    // DB Logs page
    'dblogs.title': 'Log di audit DB',
    'dblogs.show': 'Mostra',
    'dblogs.hide': 'Nascondi',
    'dblogs.empty': 'Nessuna voce di registro trovata.',
    // DB model collection names
    'model.user': 'Utente',
    'model.user_group': 'Gruppo utenti',
    'model.api_keys': 'Chiavi API',
    'model.acl_policy': 'Policy ACL',
    'model.company': 'Azienda',
    'model.conversation': 'Conversazione',
    'model.message': 'Messaggio',
    'model.avatar': 'Avatar',
    'model.user_avatar': 'Avatar utente',
    'model.knowledge': 'Conoscenza',
    'model.knowledgeGroup': 'Gruppo di conoscenza',
    'model.file': 'File',
    'model.training_job': 'Lavoro di addestramento',
    'model.avatar_knowledge': 'Conoscenza avatar',
    'model.avatar_instruction': 'Istruzione avatar',
    'model.avatar_instruction_version': 'Versione istruzione avatar',
    'model.profession_knowledge': 'Conoscenza professionale',
    'model.profession_step': 'Passo professione',
    'model.custom_models': 'Modello personalizzato',
    'model.embeddings': 'Incorporamento',
    'model.branch': 'Ramo',
    'model.profession': 'Professione',
    'model.step': 'Passo',
    'model.step_profession': 'Passo professione',
    'model.onboarding': 'Inserimento',
    'model.db_logs': 'Log DB',
    'model.question': 'Domanda',
    'model.answer': 'Risposta',
    'model.settings': 'Impostazioni',
    'model.usage_cost': 'Costo di utilizzo',
    'model.knowledge_elevenlabs_mappings': 'Mappatura ElevenLabs conoscenza',
    'model.front_sync': 'Sincronizzazione frontend',
    'model.favorite_conversation': 'Conversazione preferita',
    'model.style': 'Stile',
    'model.slotData': 'Dati slot',
    'model.payments': 'Pagamento',
    'model.account_balance': 'Saldo conto',
    'model.accountGrade': 'Livello conto',
    'model.currencyRate': 'Tasso di cambio',
    'model.test_result': 'Risultato test',
    'model.bot_test': 'Test bot',
    'model.bot_test_tester': 'Tester bot',
    'model.bot_test_target': 'Obiettivo test bot',
    'model.tutorial': 'Tutorial',
    'model.tutorial_step': 'Passo tutorial',
    'model.tutorial_section': 'Sezione tutorial',
    'model.tutorial_section_knowledge': 'Conoscenza sezione tutorial',
    'model.tutorial_section_todo': 'Todo sezione tutorial',
    'model.tutorial_participants': 'Partecipante tutorial',
    'model.todo': 'Attività',
    'model.todo_item': 'Elemento attività',
    'model.todo_item_value': 'Valore elemento attività',
    'model.cache': 'Cache',
    'model.api_tool_definition': 'Definizione strumento API',
    // DB operation names
    // WhatsApp settings
    "route.settings.comms": "Comunicazioni",
    "route.settings.comms.create": "Crea comunicazione",
    "route.settings.comms.edit": "Modifica comunicazione",
    "route.settings.comms.manage": "Gestisci comunicazione",
    "route.settings.comms.group": "Dettagli gruppo",
    "route.settings.comms.group.create": "Crea gruppo",
    "route.settings.comms.dm": "Contatto messaggio diretto",
    'socialMediaPlan.title': 'Content Studio', 'socialMediaPlan.failedToLoad': 'Errore nel caricamento', 'socialMediaPlan.newPost': 'Nuovo post', 'socialMediaPlan.library': 'Libreria', 'socialMediaPlan.search': 'Cerca...', 'socialMediaPlan.edit': 'Modifica', "socialMediaPlan.schedule.action": 'Cosa fare?', 'socialMediaPlan.back': 'Indietro', 'socialMediaPlan.next': 'Avanti', 'socialMediaPlan.cancel': 'Annulla', 'socialMediaPlan.save': 'Conferma e salva', 'socialMediaPlan.close': 'Chiudi',
    'whatsapp.loginFailed': 'Accesso WhatsApp fallito.',
    'whatsapp.logoutSuccess': 'WhatsApp disconnesso con successo.',
    'whatsapp.logoutFailed': 'Disconnessione WhatsApp fallita.',
    'whatsapp.failedToLoad': 'Impossibile caricare lo stato di WhatsApp.',
    'whatsapp.entityIdRequired': 'ID entità richiesto.',
    'whatsapp.phoneRequired': 'Il numero di telefono è obbligatorio.',
    'whatsapp.settingsSaved': 'Impostazioni WhatsApp salvate con successo.',
    'whatsapp.settingsSaveFailed': 'Impossibile salvare le impostazioni WhatsApp.',
    'whatsapp.agentStarted': 'Agente WhatsApp avviato con successo.',
    'whatsapp.agentStartFailed': 'Impossibile avviare l\'agente WhatsApp.',
    'whatsapp.agentStopped': 'Agente WhatsApp fermato con successo.',
    'whatsapp.agentStopFailed': 'Impossibile fermare l\'agente WhatsApp.',
    // WhatsApp group
    'whatsapp.groups.agentChecking': "Verifica dello stato dell'agente WhatsApp...",
    'whatsapp.groups.agentOffline': "L'agente WhatsApp è offline. Tutte le azioni che richiedono la connessione all'agente sono disabilitate.",
    // WhatsApp group gate (password access)
    // WhatsApp track logs
    // Activity panels
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp direct messages
    // WhatsApp DM detail page
    // Email Reporting (POP3) Settings
    'whatsapp.pop3SettingsSaved': 'Impostazioni report email salvate con successo.',
    'whatsapp.pop3SettingsSaveFailed': 'Impossibile salvare le impostazioni report email.',
    // ACL translations
    ...it_1.aclTranslationsIt
};
